import React, { useState, useEffect, useRef } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import './GraphStyle.css';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import SingleLineGraph from '../../d3/SingleLineGraph';
import useFetchChannelKeyGraphData from './useFetchChannelKeyGraphData';
import envConfig from '../../../envConfig';
import { selectSingleAlert } from '../../../redux/slices/singleAlertSlice/singleAlertSlice';
import { sessionHash } from '../../../utility/remoteServiceUtil';
import { selectSessionInformation } from '../../../redux/slices/sessionSlice';
import D3Utility from '../../d3/D3Utility';

/* istanbul ignore next */
function AlertGraph() {
  const {
    graphData, setGraphData, fetchGraphData,
  } = useFetchChannelKeyGraphData();

  const graphContainerRef = useRef(null);

  const { timezone, temperatureScale, airSpeedScale } = useSelector(selectSessionInformation);

  const activeAlert = useSelector(selectSingleAlert);
  const csvReportUrlBase = `${envConfig.apiUrl}/api/v1/device-data/device/samples/csv/find-by-channel-keys`;
  const dates = D3Utility.getDates(2); // start with week
  const channelType = ChannelService.getChannelTypeByValueId(activeAlert.channelKey.channelType);
  const [selectedButton, setSelectedButton] = useState(2);

  useEffect(() => {
    fetchGraphData(activeAlert.channelKey.fullChannelKey, dates.startTime, dates.endTime);
  }, []);

  const handleTimeRangeChange = (selection) => {
    const time = D3Utility.getDates(selection);
    setGraphData({
      ...graphData,
      toGraph: D3Utility.getDataInRange(graphData.originalData, time.startTime),
      startTime: time.startTime,
      endTime: time.endTime,
    });
    setSelectedButton(selection);
  };

  return (
    <div ref={graphContainerRef}>

      <div className="row mb-2">
        <div className="col-auto ml-auto text-right align-items-start">
          <a
            href={`${csvReportUrlBase}?auth_token=${sessionHash}&channelKeys=${activeAlert.channelKey.fullChannelKey}_1&startTime=${Math.ceil(graphData.startTime / 1000)}&endTime=${Math.ceil(graphData.endTime / 1000)}&airSpeedScale=${airSpeedScale}&temperatureScale=${temperatureScale}&timezone=${activeAlert.timezone}&reportName=${channelType.cloudCode}`}
            rel="noopener noreferrer"
            download={`${activeAlert.name}.csv`}
            className="text-reset text-decoration-none"
            aria-label="download csv file"
          >
            <FontAwesomeIcon
              icon="fa-sharp fa-solid fa-file-csv"
              size="lg"
              style={{ paddingTop: '6px' }}
            />
          </a>
        </div>
        <div className="col-auto text-right">
          <ToggleButtonGroup
            name="timeRange"
            onChange={handleTimeRangeChange}
            style={{ width: '232px' }}
            size="sm"
          >
            <ToggleButton
              size="sm"
              id="day"
              value={0}
              variant={selectedButton === 0 ? 'primary' : 'outline-secondary'}
            >
              24
              Hour
            </ToggleButton>
            <ToggleButton
              size="sm"
              id="twoDay"
              value={1}
              variant={selectedButton === 1 ? 'primary' : 'outline-secondary'}
            >
              48
              Hour
            </ToggleButton>
            <ToggleButton
              size="sm"
              id="week"
              value={2}
              variant={selectedButton === 2 ? 'primary' : 'outline-secondary'}
            >
              1
              Week
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>

      <SingleLineGraph
        temperatureScale={temperatureScale}
        timeZone={timezone}
        channelKeyObject={activeAlert.channelKey}
        data={graphData.toGraph}
        threshold={activeAlert.triggerCondition}
        startTime={graphData.startTime}
        endTime={graphData.endTime}
        customUnits={activeAlert.channel.unit}
        width={graphContainerRef.current ? graphContainerRef.current.offsetWidth : 525}
        height={284}
      />

    </div>
  );
}

export default AlertGraph;
